// extracted by mini-css-extract-plugin
module.exports = {"footerLinkItem":"FooterLinkItem_footerLinkItem__2vZIy","subtitle":"FooterLinkItem_subtitle__pFALi","link":"FooterLinkItem_link__3aIVJ"};